/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'list': {
    width: 16,
    height: 16,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M10 15h19v2H10zM10 8h19v2H10zM10 22h19v2H10z"/><circle pid="1" cx="5" cy="9" r="2"/><circle pid="2" cx="5" cy="16" r="2"/><circle pid="3" cx="5" cy="23" r="2"/>'
  }
})
